import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type PillVariant = "success" | "warn" | "danger" | "info" | "neutral" | "muted";

interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: PillVariant;
  dot?: boolean;
  size?: "sm" | "md";
}

const VARIANTS: Record<PillVariant, string> = {
  success: "bg-[rgba(16,185,129,0.1)] text-[#10b981]",
  warn: "bg-[rgba(245,158,11,0.1)] text-[#f59e0b]",
  danger: "bg-[rgba(239,68,68,0.1)] text-[#ef4444]",
  info: "bg-[rgba(113,112,255,0.12)] text-[var(--color-accent)]",
  neutral: "bg-[rgba(255,255,255,0.06)] text-[var(--color-fg-muted)]",
  muted: "bg-transparent text-[var(--color-fg-faint)] border border-[var(--color-border)]",
};

export function Pill({
  variant = "neutral",
  dot = true,
  size = "md",
  className,
  children,
  ...props
}: PillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium tracking-[-0.13px] whitespace-nowrap",
        size === "sm" ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-[11px]",
        VARIANTS[variant],
        className,
      )}
      {...props}
    >
      {dot && <span className="size-1.5 rounded-full bg-current shrink-0" />}
      {children}
    </span>
  );
}
